export const routeMixin = {
    computed: {
        isCategoryRoute() {
            if (
                this.$globalConstants.host['smart_consumer_tips_article_list']
            ) {
                return false;
            }

            if (this.$globalConstants.host['gw_article_content']) {
                return false;
            }

            return (
                this.$route.name === 'home' || this.$route.name === 'category'
            );
        },
    },
    methods: {
        getCategorySlug() {
            return this.$route.params.category
                ? this.$route.params.category
                : 'default';
        },
    },
};
